import React from "react";
import { useCart } from "../context/CartContext";
import { MessageCircle, ShieldCheck } from "lucide-react";
import { motion } from "framer-motion";

export default function PaymentPage() {
  const { cart, total } = useCart();

  /* ================================
     WhatsApp Order (ONLY)
  ================================ */
  const handleWhatsAppOrder = () => {
    if (!cart.length) {
      alert("Your cart is empty");
      return;
    }

    const itemsText = cart
      .map(
        (item) =>
          `${item.name} x ${item.qty} = ₹${item.price * item.qty}`
      )
      .join("%0A");

    const message =
      `Hello ANE CROCHET 🧶%0A` +
      `I’d like to place an order.%0A%0A` +
      `Items:%0A${itemsText}%0A%0A` +
      `Total: ₹${total}`;

    window.open(
      `https://wa.me/916001550558?text=${message}`,
      "_blank"
    );
  };

  return (
    <div className="min-h-screen bg-[#FFF5F7] text-[#3A2F2F]">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-xl mx-auto pt-24 px-6"
      >
        <h1 className="text-4xl font-black text-center mb-6">
          Confirm <span className="text-[#25D366]">Order</span>
        </h1>

        <div className="bg-white/70 rounded-[3rem] p-10 shadow-2xl">
          {cart.map((item) => (
            <div key={item.id} className="flex justify-between mb-2">
              <span>{item.name} × {item.qty}</span>
              <span>₹{item.price * item.qty}</span>
            </div>
          ))}

          <div className="text-right text-2xl font-black text-[#25D366] mt-4">
            ₹{total}
          </div>

          <motion.button
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
            onClick={handleWhatsAppOrder}
            className="w-full mt-8 py-6 rounded-[1.6rem] bg-[#25D366] text-white font-black text-lg"
          >
            <MessageCircle className="inline mr-2" />
            Order via WhatsApp
          </motion.button>

          <div className="mt-6 text-center text-xs text-[#7A6A6A]">
            <ShieldCheck className="inline mr-1 text-green-500" />
            No online payment • Manual confirmation on WhatsApp
          </div>
        </div>
      </motion.div>
    </div>
  );
}
